import { Link } from 'react-router-dom';
import { Zoom } from 'react-awesome-reveal';
import Lottie from 'react-lottie';
const defaultOptions = {
    loop: true,
    autoplay: true,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
export const CardItem = ({ icon = undefined, title, text, onClick = undefined, lottie = undefined, delay = 0, to = undefined }) => {
    const cardClasses = `card-item-box h-100 ${onClick || to ? ' pointer ' : ''}`
    const cardContent = (
        <>
            {lottie ?
                <div className='lottie-wrapper' style={{ width: 100 }}>
                    <Lottie options={{ ...defaultOptions, animationData: lottie }}
                        height={100}
                        width={100}
                        style={{ textAlign: 'left' }}

                    />
                </div> : <i className={`${icon} text-primary mb-3`} aria-hidden="true"></i>

            }

            <h4 className='value-title mt-4 text-white pb-2 fs-5'>{title}</h4>
            <div className="line my-3"></div>
            <p className='value-text text-white fs-18 pt-2 mb-0'>{text}</p>
        </>
    )

    return (
        <Zoom delay={delay}
            triggerOnce={true}
            className='h-100'
        >
            {to ? (
                <Link className={cardClasses} onClick={onClick} to={to}>
                    {cardContent}
                </Link>
            ) : (
                <div className={cardClasses} onClick={onClick}>
                    {cardContent}
                </div>
            )}
        </Zoom>
    )
}
